<patron-toolbar>
  <div class="container">
    <div class="flex justify-content-between flex-wrap">
      <div class="my-2 flex align-items-center">
        <div>
          <patron-filter-widget
            [findOptions]="findOptions"
            (onSubmit)="goToFirstPage()"></patron-filter-widget>
        </div>
      </div>
      <div class="my-2 flex align-items-center">
        <patron-search-widget (onSearch)="onSearch($event)" #searchWidget></patron-search-widget>
      </div>
    </div>
  </div>
</patron-toolbar>

<div class="container">
  <patron-responsive-table
    [bodyTemplate]="tableBody"
    [items]="entities"
    [loading]="loading"
    [findOptions]="findOptions"
    [mobileSortable]="false"
    (sortChanged)="paginate($event)"
    #table>
    <ng-template #tableBody let-item>
      <tr>
        <td>
          <patron-rt-column-title>
            <strong>Data</strong>
          </patron-rt-column-title>
          <div>
            <div>
              <small>Criado em {{ item.created_at | date: 'dd/MM/yyyy HH:mm' }}</small>
            </div>
            @if (isExpired(item.expiration_date)) {
              <div>
                <patron-badge color="danger">Expirado</patron-badge>
              </div>
            }
            @if (item.expiration_date && !isExpired(item.expiration_date)) {
              <div>
                <small>Expira em {{ item.expiration_date | date: 'dd/MM/yyyy HH:mm' }}</small>
              </div>
            }
          </div>
        </td>
        <td>
          <patron-rt-column-title>
            <strong>Link</strong>
          </patron-rt-column-title>
          <div>
            <a [href]="item.url" target="_blank">
              <span [innerHTML]="item.url | highlight: findOptions.q!"></span>
            </a>
          </div>
        </td>
        <td>
          <patron-rt-column-title>
            <strong>Cliente</strong>
          </patron-rt-column-title>
          <div>
            <span [innerHTML]="item.customer_name | highlight: findOptions.q!"></span>
          </div>
        </td>
        <td>
          <patron-rt-column-title>
            <strong>Ref doc</strong>
          </patron-rt-column-title>
          <div class="flex align-items-center gap-2">
            {{ getType(item.type) }}
            @if (!item.ref_order) {
              <span>(Sem n°)</span>
            }
            <span [innerHTML]="item.ref_order | highlight: findOptions.q!"></span>
          </div>
        </td>
        <td>
          <patron-rt-column-title>
            <strong>Valor</strong>
          </patron-rt-column-title>
          <div>
            {{ item.amount | currency: 'BRL' }}
          </div>
        </td>
        <td>
          <patron-rt-column-title>
            <strong>Status</strong>
          </patron-rt-column-title>
          <div class="text-right">
            <payment-link-status-badge [status]="item.status"></payment-link-status-badge>
            <div>
              <small>{{ item.payment_method_id }}</small>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>
  </patron-responsive-table>
</div>

<patron-toolbar position="bottom" [class.hidden]="!entities.length">
  <patron-paginator
    [totalRecords]="totalItems"
    [findOptions]="findOptions"
    (onPageChange)="paginate($event)"
    #paginator>
  </patron-paginator>
</patron-toolbar>
